import { render, staticRenderFns } from "./MemolanguageFlytogetLanguagesView.vue?vue&type=template&id=77290a39&scoped=true&"
import script from "./MemolanguageFlytogetLanguagesView.vue?vue&type=script&lang=js&"
export * from "./MemolanguageFlytogetLanguagesView.vue?vue&type=script&lang=js&"
import style0 from "./MemolanguageFlytogetLanguagesView.vue?vue&type=style&index=0&id=77290a39&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77290a39",
  null
  
)

/* custom blocks */
import block0 from "./MemolanguageFlytogetLanguagesView.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports